<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard', params: { vendorId } }">
    <bids-view :override-list-configuration="listConfiguration" />
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import BidsView from "@/client/applications/justopp/views/Bids";

export default {
  name: "Bids",
  components: { BidsView },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.bids.pageTitle",
      subTitle: "justopp.bids.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      listConfiguration: {
        constantFilters: {
          VendorId: this.sg("user.profile")?.Vendor?.id,
        },
      },
    };
  },
};
</script>

<style></style>
